// extracted by mini-css-extract-plugin
module.exports = {"hasActiveCalls":"PhoneBtn_hasActiveCalls__ugaTo","shadowSpreadVibration":"PhoneBtn_shadowSpreadVibration__2oW6T"};